import { type Experiment } from './use-experiment';

const booleanTypeGuard = (value: unknown): value is boolean => typeof value === 'boolean';

export const jsmgrowth535PreviewPlayground = {
	experimentName: 'jsmgrowth_535_preview_playground',
	parameterName: 'isEnabled',
	defaultValue: false,
	options: {
		fireExperimentExposure: true,
		typeGuard: booleanTypeGuard,
	},
	targeting: {
		cohort: () => true,
	},
	metadata: {
		description: 'New JSM product tour page with advanced preview playground',
		expectedReleaseDate: '10/25/2026',
		expectedRuntime: '30 days',
		context: {
			urls: ['/software/jira/service-management'],
		},
	},
} satisfies Experiment<boolean>;
